import { render } from "./ProfileUpdate.vue?vue&type=template&id=195751b2"
import script from "./ProfileUpdate.vue?vue&type=script&lang=js"
export * from "./ProfileUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Junior/ProjectPile/smartpile-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__